export default __webpack_public_path__ + "static/media/slider3.7ad29aab.PNG";